import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import schedule from '../data/scheduledPosts.json';

// Blog posts data (add new posts here)
const posts = [
  {
    id: 50,
    title: 'Why Is My Thumb Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'That flicker at the base of your thumb is almost always benign — from texting overuse to caffeine and BFS. What causes it, how to calm it, and when it is worth a doctor’s look.',
    slug: 'thumb-twitching',
    imageUrl: 'https://images.pexels.com/photos/34200724/pexels-photo-34200724.jpeg',
    imageAlt: 'An open human hand with the thumb clearly visible against a grey background.',
  },
  {
    id: 49,
    title: 'Why Is My Finger Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'A finger that twitches on its own is one of the most common, most harmless twitches there is. The real causes — typing, stress, caffeine, nerves — and how to settle it.',
    slug: 'finger-twitching',
    imageUrl: 'https://images.pexels.com/photos/97166/pexels-photo-97166.jpeg',
    imageAlt: 'A relaxed human hand and fingers resting on pale pebbles.',
  },
  {
    id: 48,
    title: 'Why Is My Hand Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'Hand twitching is usually harmless overuse, stress, or carpal-tunnel territory — not something sinister. A calm, complete guide to why it happens and how to ease it.',
    slug: 'hand-twitching',
    imageUrl: 'https://images.pexels.com/photos/1206877/pexels-photo-1206877.jpeg',
    imageAlt: 'A human hand resting on a cool grey stone surface.',
  },
  {
    id: 47,
    title: 'Why Is My Arm Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'Why your bicep or forearm twitches — and an honest, reassuring answer to the “is my left arm a heart problem?” worry, plus when a symptom truly needs urgent care.',
    slug: 'arm-twitching',
    imageUrl: 'https://images.pexels.com/photos/26614337/pexels-photo-26614337.jpeg',
    imageAlt: 'A person’s bare forearm in natural light.',
  },
  {
    id: 46,
    title: 'Why Is My Foot Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'Foot twitching, especially at rest or in bed, is almost always benign. The everyday causes, the footwear and stress links, and the signs worth checking.',
    slug: 'foot-twitching',
    imageUrl: 'https://images.pexels.com/photos/10601904/pexels-photo-10601904.jpeg',
    imageAlt: 'Bare feet resting on green grass.',
  },
  {
    id: 45,
    title: 'Why Is My Thigh Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'The big thigh muscles twitch after exercise just like the calves do — usually harmlessly. The causes, the anxiety link, and how to calm a twitching thigh.',
    slug: 'thigh-twitching',
    imageUrl: 'https://images.pexels.com/photos/9486767/pexels-photo-9486767.jpeg',
    imageAlt: 'Two people’s legs against a plain grey background.',
  },
  {
    id: 44,
    title: 'Why Is My Back Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'Back twitching is usually posture, tension, or strain in the muscles that hold you upright. What causes it, how to settle it, and the red flags that need prompt care.',
    slug: 'back-twitching',
    imageUrl: 'https://images.pexels.com/photos/7298685/pexels-photo-7298685.jpeg',
    imageAlt: 'A person in activewear with a hand on their lower back.',
  },
  {
    id: 43,
    title: 'Why Is My Stomach Twitching? Causes, Anxiety, and When to Worry',
    date: 'July 30, 2026',
    excerpt: 'That flutter in your belly is almost always the abdominal wall muscle — not your organs. Reassurance on the “is it my heartbeat or a baby?” worry, and when to check.',
    slug: 'stomach-twitching',
    imageUrl: 'https://images.pexels.com/photos/7298668/pexels-photo-7298668.jpeg',
    imageAlt: 'A person with both hands resting on their abdomen.',
  },
  {
  id: 42,
  title: 'BFS and Exercise: Does Working Out Make Twitching Worse?',
  date: 'April 29, 2026',
  excerpt: 'Does exercise make BFS twitching worse? Learn why muscles twitch more after workouts, whether you should keep exercising, and how to manage symptoms safely.',
  slug: 'bfs-exercise-twitching',
  imageUrl: 'https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg',
  imageAlt: 'Person exercising, representing muscle activity and twitching after workouts.',
  },
  {
  id: 41,
  title: 'Perceived Weakness vs Clinical Weakness in BFS: The Critical Difference',
  date: 'April 29, 2026',
  excerpt: 'Feeling weak and being clinically weak are two very different things. This guide explains the distinction, why BFS causes perceived weakness, and what a neurologist actually looks for.',
  slug: 'perceived-weakness-vs-clinical-weakness-bfs',
  imageUrl: 'https://images.pexels.com/photos/8769387/pexels-photo-8769387.jpeg',
  imageAlt: 'A neurologist performing a clinical strength examination on a patient.',
  },
  {
  id: 40,
  title: 'Internal Tremors at Night: Why It Happens When You’re Resting or Falling Asleep',
  date: 'March 15, 2026',
  excerpt:
    'Why do internal tremors feel stronger at night or while falling asleep? Learn how anxiety, rest, sleep transitions, and benign nerve hyperexcitability can make internal shaking more noticeable.',
  slug: 'internal-tremors-at-night',
  imageUrl:
    'https://images.pexels.com/photos/6941126/pexels-photo-6941126.jpeg',
  imageAlt:
    'Person lying awake in bed at night, noticing internal tremor sensations while trying to fall asleep.',
},
  {
  id: 39,
  title: 'Tongue Fasciculations: Causes, Anxiety, and When to Worry',
  date: 'March 15, 2026',
  excerpt: 'Worried about tongue fasciculations? Learn the common causes, the role of anxiety and BFS, how they differ from bulbar ALS, and when to seek medical care.',
  slug: 'tongue-fasciculations-causes',
  imageUrl: 'https://cdn.pixabay.com/photo/2015/06/26/12/20/tongue-822441_1280.jpg',
  imageAlt: 'Close-up of a human tongue, a common site of benign fasciculations.',
  },
  {
    id: 38,
    title: 'Benign Fasciculation Syndrome Sensory Symptoms: Burning, Tingling, and Paresthesia',
    date: 'March 15, 2026',
    excerpt: 'Can BFS cause burning, tingling, pins and needles, or strange sensory symptoms? This guide explains why BFS is often more than twitching and why sensory symptoms often point away from ALS.',
    slug: 'benign-fasciculation-syndrome-sensory-symptoms',
    imageUrl: 'https://images.pexels.com/photos/4804019/pexels-photo-4804019.jpeg',
    imageAlt: 'Person noticing odd nerve sensations in the arm while checking muscle strength.',
  },
  {
    id: 37,
    title: 'Muscle Twitching in One Spot vs All Over: What It Really Means',
    date: 'December 2, 2025',
    excerpt: 'Is it worse to twitch in one stubborn muscle or to feel flickers all over your body? This guide explains how neurologists interpret twitch patterns, the role of BFS and anxiety, and when to truly worry.',
    slug: 'muscle-twitching-one-spot-vs-all-over',
    imageUrl: 'https://images.pexels.com/photos/221210/pexels-photo-221210.jpeg',
    imageAlt: 'Person sitting on a sofa, noticing muscle twitching in one leg.',
  },
  {
    id: 36,
    title: 'Muscle Twitching After Eating: Causes, Anxiety, and When to Worry',
    date: 'November 25, 2025',
    excerpt: 'Do your legs twitch after a meal? Or do you feel internal shaking after sugar? We explain the "gut-twitch axis," blood sugar triggers, and why it is rarely serious.',
    slug: 'muscle-twitching-after-eating',
    imageUrl: 'https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'Person eating a healthy balanced meal to prevent blood sugar spikes',
  },
  {
    id: 35,
    title: 'Internal Vibrations: Causes, Anxiety, and When to Worry',
    date: 'November 20, 2025',
    excerpt: 'Does it feel like a cell phone is buzzing inside your body? We explain the causes of internal tremors, the link to BFS and anxiety, and why it is usually benign.',
    slug: 'internal-vibrations-causes',
    imageUrl: 'https://images.pexels.com/photos/1809342/pexels-photo-1809342.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'Person holding a warm cup of tea, checking for tremors while relaxing',
  },
  {
    id: 34,
    title: 'Muscle Twitching in Sleep: Causes, Anxiety, and When to Worry',
    date: 'November 15, 2025',
    excerpt: 'Waking up to a jolt? Or feeling your legs pop the moment you lie down? We explain the science of sleep myoclonus, hypnic jerks, and how to calm your nerves at night.',
    slug: 'muscle-twitching-in-sleep',
    imageUrl: 'https://images.pexels.com/photos/355863/pexels-photo-355863.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'Person sleeping peacefully in a comfortable bed',
  },
  {
    id: 32,
    title: 'Why Is My Body Twitching All Over? A Complete, Reassuring Guide',
    date: 'October 15, 2025',
    excerpt: 'If your muscles are popping like popcorn, you aren\'t alone. We explain the real causes of widespread twitching—from BFS to anxiety—and why it\'s rarely a sign of serious disease.',
    slug: 'why-is-my-body-twitching-all-over',
    imageUrl: 'https://images.pexels.com/photos/4471314/pexels-photo-4471314.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'Person relaxing and stretching to relieve muscle tension',
  },
  {
    id: 31, // Use the next available ID
    title: 'How Long Does BFS Last? A Guide to Timelines & Prognosis',
    date: 'October 6, 2025',
    excerpt: 'Will BFS ever go away? A detailed guide on the timeline for Benign Fasciculation Syndrome, from weeks to years, and a reassuring look at its excellent long-term prognosis.',
    slug: 'how-long-does-bfs-last',
    imageUrl: 'https://images.pexels.com/photos/897817/pexels-photo-897817.jpeg',
    imageAlt: 'A winding road through a forest, symbolizing the unpredictable timeline of BFS.',
  },
  {
  id: 29, // Or the next sequential ID
  title: 'Tongue Twitching: A Reassuring Guide to a Scary BFS Symptom',
  date: 'September 23, 2025',
  excerpt: 'A deep dive into benign tongue twitching (fasciculations). Learn why it happens in BFS, the crucial differences from ALS symptoms like slurred speech, and how to find peace of mind.',
  slug: 'tongue-twitching-bfs',
  imageUrl: 'https://cdn.pixabay.com/photo/2015/06/26/12/20/tongue-822441_1280.jpg',
  imageAlt: 'A person examining their tongue in the mirror, representing concern over tongue twitching.',
},
  {
  id: 28, // Or the next sequential ID
  title: 'Magnesium and Calf Twitching: Can Supplements Really Help?',
  date: 'September 23, 2025',
  excerpt: 'A deep dive into the link between magnesium deficiency and calf twitching. Learn how magnesium calms nerves, which supplement forms are best, and how to use it safely for relief.',
  slug: 'calf-twitching-magnesium',
  imageUrl: 'https://cdn.pixabay.com/photo/2020/04/12/09/53/vitamin-5033571_1280.jpg',
  imageAlt: 'Almonds and leafy greens, excellent food sources of magnesium.',
},
  {
  id: 27, // Or the next sequential ID
  title: 'Can Dehydration Cause Calf Twitching? Electrolytes, Water, and Nerve Health',
  date: 'September 22, 2025',
  excerpt: 'The definitive guide to how dehydration and electrolyte imbalances cause calf twitching. Learn the roles of magnesium, potassium, and sodium, and how to hydrate correctly to calm your nerves.',
  slug: 'calf-twitching-dehydration',
  imageUrl: 'https://cdn.pixabay.com/photo/2016/02/18/06/57/glass-1206584_1280.jpg',
  imageAlt: 'A glass of water with lemon and mint, symbolizing proper hydration with electrolytes.',
},
  {
  id: 26, // Or the next sequential ID
  title: 'Why Do My Legs Twitch at Rest? The Ultimate Guide to Calf Fasciculations',
  date: 'September 22, 2025',
  excerpt: 'The definitive pillar guide to leg twitching at rest. A deep dive into the common causes of calf fasciculations, from benign triggers like stress and exercise to BFS, and how it differs from RLS.',
  slug: 'leg-twitching-at-rest',
  imageUrl: 'https://images.pexels.com/photos/15418246/pexels-photo-15418246.jpeg',
  imageAlt: 'A person\'s legs resting on a couch, a common time to notice benign fasciculations.',
},
  {
id: 25, // next sequential id
title: 'Persistent Calf Twitching: When to Relax and When to See a Doctor',
date: 'September 18, 2025',
excerpt: 'Chronic calf twitching can feel scary, but most cases are benign. This guide explains causes, reassurance, and clear red flags for when to see a doctor.',
slug: 'persistent-calf-twitching',
imageUrl: 'https://images.pexels.com/photos/4422911/pexels-photo-4422911.jpeg',
imageAlt: 'Close-up of a calf muscle, a common site of benign fasciculations.'
},
  {
  id: 24, // Or the next available number
  title: 'Calf Cramps vs. Twitching: How to Tell Them Apart and Find Relief',
  date: 'September 18, 2025',
  excerpt: 'A clear guide to the key differences between a painful calf cramp and a harmless twitch (fasciculation). Learn the overlapping causes and targeted strategies for relief.',
  slug: 'calf-cramps-vs-twitching',
  imageUrl: 'https://images.pexels.com/photos/4167541/pexels-photo-4167541.jpeg',
  imageAlt: 'A person massaging their calf to relieve a cramp.',
},
  {
  id: 23, // Or the next available number
  title: 'Muscle Twitching Without Weakness: Why It’s Usually Benign (Including Calves)',
  date: 'September 17, 2025',
  excerpt: 'It\'s the single most important question you can ask. This definitive guide explains why the absence of weakness is the most powerful sign that your twitching is harmless.',
  slug: 'muscle-twitching-no-weakness',
  imageUrl: 'https://images.pexels.com/photos/4804019/pexels-photo-4804019.jpeg',
  imageAlt: 'A person flexing their bicep, symbolizing muscle strength despite twitching.',
},
  {
    id: 22,
    title: 'Calf Twitching and ALS Fears: How to Tell the Difference',
    date: 'September 16, 2025',
    excerpt: 'The definitive guide to distinguishing benign calf twitching (BFS) from fasciculations in ALS. Learn why the absence of weakness is the key reassuring sign.',
    slug: 'calf-twitching-als',
    imageUrl: 'https://images.pexels.com/photos/7089017/pexels-photo-7089017.jpeg',
    imageAlt: 'A neurologist performing a clinical strength test on a patient\'s leg.',
  },
  {
    id: 21,
    title: 'Calf Twitching and Anxiety: How Stress Creates a Vicious Cycle',
    date: 'September 11, 2025',
    excerpt: 'It’s the frustrating loop that keeps you up at night: the more you worry about your twitching calves, the more they twitch. We’ll show you why this happens and how to break the cycle for good.',
    slug: 'calf-twitching-anxiety',
    imageUrl: 'https://images.pexels.com/photos/12572396/pexels-photo-12572396.jpeg',
    imageAlt: 'A visual metaphor for the feedback loop of anxiety, showing a circular chain.',
  },
  {
    id: 20,
    title: 'Calf Muscle Twitching at Night: What’s Really Happening While You Sleep',
    date: 'September 11, 2025',
    excerpt: 'That frustrating "popcorn" feeling in your calves just as you’re trying to sleep is a common complaint. We dive deep into the science and provide a complete plan to reclaim your rest.',
    slug: 'calf-muscle-twitching-at-night',
    imageUrl: 'https://images.pexels.com/photos/935777/pexels-photo-935777.jpeg',
    imageAlt: 'A person\'s legs under the covers in bed, representing the experience of calf twitching at night.',
  },
  {
    id: 19,
    title: 'Why Do My Calves Twitch After Exercise? Harmless Causes vs. Red Flags',
    date: 'September 10, 2025',
    excerpt: 'You’ve just finished a great workout, but now your calf muscles are putting on their own show. We break down the science of post-exercise twitching and tell you when it’s normal and when to pay attention.',
    slug: 'calf-twitching-after-exercise',
    imageUrl: 'https://images.pexels.com/photos/1092874/pexels-photo-1092874.jpeg',
    imageAlt: 'A runner\'s legs in motion, highlighting the calf muscles used during exercise.',
  },
  {
    id: 18,
    title: 'Vitamin Deficiency and Eye Twitching: What Nutrients Help?',
    date: 'September 10, 2025',
    excerpt: 'That persistent eyelid flutter could be a sign that your body is missing something crucial. We dive into the science of the key vitamins and minerals that calm twitchy nerves.',
    slug: 'vitamin-deficiency-eye-twitching',
    imageUrl: 'https://images.pexels.com/photos/7208641/pexels-photo-7208641.jpeg',
    imageAlt: 'A colorful array of healthy foods rich in vitamins and minerals like magnesium and potassium.',
  },
  {
    id: 17,
    title: 'Eye Twitching at Night: Why It Happens and How to Sleep Better',
    date: 'September 10, 2025',
    excerpt: 'You’re finally ready for bed, but your eyelid has other plans. We explore the science behind nighttime twitches and offer a complete plan to reclaim your rest.',
    slug: 'eye-twitching-at-night',
    imageUrl: 'https://images.pexels.com/photos/1028741/pexels-photo-1028741.jpeg',
    imageAlt: 'A person trying to sleep in a dark room, representing the frustration of eye twitching at night.',
  },
  {
    id: 16,
    title: 'Left vs Right Eye Twitching: Myths, Superstitions, and Medical Facts',
    date: 'September 10, 2025',
    excerpt: 'Does a twitch in your left eye mean bad luck? Does the right mean good fortune? We explore the fascinating global myths before diving into what’s *really* happening with your eye.',
    slug: 'left-vs-right-eye-twitching',
    imageUrl: 'https://images.pexels.com/photos/801867/pexels-photo-801867.jpeg',
    imageAlt: 'A person with one eye highlighted, representing the focus on left vs right eye twitching.',
  },
  {
    id: 15,
    title: 'Caffeine and Eye Twitching: Is Your Morning Coffee the Culprit?',
    date: 'September 10, 2025',
    excerpt: 'That beloved cup of coffee might be the hidden reason for your annoying eyelid flutter. We uncover the science, reveal your true daily intake, and offer a plan to stop the twitch.',
    slug: 'caffeine-and-eye-twitching',
    imageUrl: 'https://images.pexels.com/photos/1235706/pexels-photo-1235706.jpeg',
    imageAlt: 'A cup of coffee next to a laptop, symbolizing the link between caffeine and eye twitching.',
  },
  {
    id: 14,
    title: 'Eye Twitching Anxiety: Why Stress Makes It Worse (and How to Stop It)',
    date: 'September 9, 2025',
    excerpt: 'It’s the ultimate catch-22: the more you worry about your eye twitching, the more it twitches. This guide breaks down the science behind this vicious cycle and gives you the tools to finally break free.',
    slug: 'eye-twitching-anxiety',
    imageUrl: 'https://images.pexels.com/photos/609549/pexels-photo-609549.jpeg',
    imageAlt: 'A person looking stressed, representing the cycle of eye twitching and anxiety.',
  },
  {
    id: 13,
    title: 'Eyeball Spasms vs. Eyelid Twitching: What’s the Difference?',
    date: 'September 9, 2025',
    excerpt: 'Worried about an eyeball spasm? This guide explains the crucial differences between a harmless eyelid twitch and a true eyeball spasm, what causes them, and when to see a doctor.',
    slug: 'eyeball-spasm-vs-eyelid-twitch',
    imageUrl: 'https://images.pexels.com/photos/63320/eye-eyelashes-face-woman-63320.jpeg',
    imageAlt: 'Anatomical drawing showing the difference between eyelid and eyeball muscles.',
  },
  {
    id: 12,
    title: 'Is Eye Twitching a Disease? What Doctors Actually Say',
    date: 'September 9, 2025',
    excerpt: 'Is your eye twitching a disease? A doctor\'s perspective on when an eye twitch is a benign symptom vs. a sign of a neurological disease like blepharospasm or MS.',
    slug: 'is-eye-twitching-a-disease',
    imageUrl: 'https://images.pexels.com/photos/7089020/pexels-photo-7089020.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'A doctor explaining the difference between a symptom and a disease to a patient.',
  },
  {
    id: 11,
    title: 'Eye Spasm: Complete Guide to Stress, Fatigue & Screen Time Triggers',
    date: 'September 9, 2025',
    excerpt: 'A comprehensive guide to how stress, fatigue, and screen time trigger eyelid spasms, plus proven solutions that work to provide lasting relief.',
    slug: 'eye-spasms-stress-fatigue-screen-time',
    imageUrl: 'https://cdn.pixabay.com/photo/2018/11/09/18/38/eye-3805227_1280.jpg',
    imageAlt: 'Person experiencing an eye spasm from stress and prolonged screen time',
  },
  {
    id: 10,
    title: 'Eye Muscle Twitch: Complete Guide to Triggers, Remedies & Treatment',
    date: 'September 9, 2025',
    excerpt: 'Experiencing annoying eyelid twitching? Discover the science behind eye muscle spasms, proven natural remedies, and expert advice on when to seek medical attention.',
    slug: 'eye-muscle-twitch-triggers',
    imageUrl: 'https://images.pexels.com/photos/3769021/pexels-photo-3769021.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'Person rubbing tired eyes, a common cause of eye muscle twitching',
  },
  {
    id: 9,
    title: 'Why Won\'t My Eye Stop Twitching? A Guide to Causes & Remedies',
    date: 'September 8, 2025',
    excerpt: 'It started as a minor annoyance, but now it\'s a constant, distracting flutter. Here’s what’s really going on and how you can take back control.',
    slug: 'why-eye-keeps-twitching',
    imageUrl: 'https://images.pexels.com/photos/5473183/pexels-photo-5473183.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt: 'A frustrated person looking at a computer screen, representing persistent eye twitching',
  },
  {
    id: 8,
    title: 'Why Is My Eye Twitching? A Deep Dive into Causes & Anxiety',
    date: 'September 7, 2025',
    excerpt: 'An in-depth guide to eyelid twitching. We cover common causes, its link to BFS, and how to break the anxiety-twitching cycle.',
    slug: 'eye-twitching-causes',
    imageUrl: 'https://cdn.pixabay.com/photo/2017/11/20/15/52/knuckles-2965906_1280.jpg',
    imageAlt: 'Close-up of a person\'s eye, representing the sensation of an eye twitch',
  },
  {
    id: 7,
    title: 'Why Are My Calves Twitching? Causes, Anxiety, and When to Worry',
    date: 'September 6, 2025',
    excerpt: 'Experiencing calf twitching? Learn the common causes — from exercise and stress to Benign Fasciculation Syndrome (BFS) — and how to tell it apart from serious conditions like ALS.',
    slug: 'calf-twitching-causes',
    imageUrl: 'https://images.pexels.com/photos/8436687/pexels-photo-8436687.jpeg',
    imageAlt: 'Person holding their calf muscle, which is a common spot for benign twitching',
  },
  {
    id: 6,
    title: 'Benign Fasciculation Syndrome vs. ALS: Understanding the Critical Differences',
    date: 'September 6, 2025',
    excerpt:
      'Worried about muscle twitches? This comprehensive guide explains the crucial differences between Benign Fasciculation Syndrome vs. ALS, providing medical clarity and reassurance for those experiencing fasciculations.',
    slug: 'benign-fasciculation-syndrome-vs-als',
    imageUrl:
      'https://images.pexels.com/photos/5327921/pexels-photo-5327921.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    imageAlt:
      'Medical professional explaining the differences between BFS and ALS',
  },
  {
    id: 5,
    title: 'Benign Fasciculation Syndrome Treatment: Managing Symptoms & Finding Relief',
    date: 'September 6, 2025',
    excerpt:
      'Looking for benign fasciculation syndrome treatment options? Learn evidence-informed approaches—from lifestyle changes and anxiety management to when to see a neurologist.',
    slug: 'benign-fasciculation-syndrome-treatment',
    imageUrl:
      'https://images.pexels.com/photos/1051838/pexels-photo-1051838.jpeg',
    imageAlt:
      'Doctor discussing benign fasciculation syndrome treatment options with a patient',
  },
  {
    id: 4,
    title: 'A Comprehensive Guide to Benign Fasciculation Syndrome Symptoms',
    date: 'September 6, 2025',
    excerpt:
      'Experiencing persistent muscle twitches? This guide breaks down benign fasciculation syndrome symptoms—from fasciculations and cramps to triggers and coping.',
    slug: 'benign-fasciculation-syndrome-symptoms',
    imageUrl:
      'https://cdn.pixabay.com/photo/2022/06/24/17/35/relaxation-7282116_1280.jpg',
    imageAlt: 'Person looking at calf muscle where twitching is occurring',
  },
  {
  id: 3, // Use the next sequential ID
  title: 'How I Cured My Benign Fasciculation Syndrome: A Personal Story',
  date: 'September 6, 2025',
  excerpt: 'A personal story of overcoming BFS through lifestyle changes, anxiety management, and community support. Find hope and practical strategies.',
  slug: 'how-i-cured-benign-fasciculation-syndrome',
  imageUrl: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg',
  imageAlt: 'A group of people supporting each other, symbolizing community.',
},
];

// Drip schedule: some posts are released on a future date. Until a post's
// publishAt has arrived, it's hidden from this index (the server-side reveal
// cron adds it to the sitemap + prerendered HTML on the day). For scheduled
// posts we also show the scheduled date as the card date. This is a client-side
// convenience filter; the authoritative gate is the prerender/reveal step.
const SCHEDULE = Object.fromEntries(schedule.posts.map((p) => [p.slug, p.publishAt]));
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
  'August', 'September', 'October', 'November', 'December'];
const formatIso = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};
const todayIso = new Date().toISOString().slice(0, 10);

const sortedPosts = [...posts]
  .filter((p) => !SCHEDULE[p.slug] || SCHEDULE[p.slug] <= todayIso)
  .map((p) => (SCHEDULE[p.slug] ? { ...p, date: formatIso(SCHEDULE[p.slug]) } : p))
  .sort((a, b) => new Date(b.date) - new Date(a.date));

const BlogPage = () => {
  return (
    <>
      {/* Inline styles for the new list layout */}
      <style>
        {`
          .blog-list-card {
            border: none;
            transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
            border-radius: 0.75rem; /* Slightly larger radius */
            overflow: hidden; /* Ensures the image corners are clipped */
          }
          .blog-list-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          }
          .blog-list-img {
            height: 100%;
            width: 100%;
            object-fit: cover;
          }
          .blog-list-card .btn-primary {
            background-color: #003f5c;
            border-color: #003f5c;
            border-radius: 9999px;
            font-weight: 600;
          }
          .blog-list-card .btn-primary:hover {
            background-color: #002c40;
            border-color: #002c40;
          }
        `}
      </style>

      {/* ========== BLOG PAGE HERO BANNER (No changes here) ========== */}
      <div
        style={{
          backgroundColor: '#003f5c',
          color: '#fff',
          padding: '5rem 0',
          textAlign: 'center',
          marginBottom: '4rem',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.8rem' }}>
            BFS Blog
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              maxWidth: '700px',
              margin: '1rem auto',
              opacity: '0.9',
            }}
          >
            Insights, stories, and the latest information on living with Benign
            Fasciculation Syndrome.
          </p>
        </Container>
      </div>

      {/* ========== BLOG POSTS LIST ========== */}
      <Container className="mb-5">
        {sortedPosts.map((post) => (
          // Each post is now wrapped in its own Row for vertical listing
          <Row key={post.id} className="justify-content-center mb-4">
            <Col md={10} lg={9}>
              <Card className="blog-list-card shadow-sm">
                <Row className="g-0">
                  {/* Image Column */}
                  <Col md={4}>
                    <img
                      src={post.imageUrl}
                      alt={post.imageAlt || post.title}
                      className="blog-list-img"
                    />
                  </Col>
                  {/* Content Column */}
                  <Col md={8}>
                    <Card.Body className="d-flex flex-column p-4">
                      <Card.Title as="h4" className="fw-bold mb-2">
                        {post.title}
                      </Card.Title>
                      <Card.Subtitle className="mb-3 text-muted small">
                        {post.date}
                      </Card.Subtitle>
                      <Card.Text className="flex-grow-1">
                        {post.excerpt}
                      </Card.Text>
                      <Button
                        as={Link}
                        to={`/blog/${post.slug}`}
                        variant="primary"
                        className="mt-3 align-self-start px-4"
                      >
                        Read More
                      </Button>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        ))}
      </Container>
    </>
  );
};

export default BlogPage;

